import Swiper, { Autoplay, Navigation, Pagination, EffectFade } from 'swiper'

Swiper.use([Autoplay, Navigation, Pagination, EffectFade])

export default class Home {
    constructor () {
        if (document.getElementById('home') !== null) {
            this.initOffices()
            this.initSocial()
            this.propertySlider()
            this.reviewSlider()
            this.projectsSlider()
        }
    }

    initOffices () {
        const offices = document.querySelectorAll('#offices .content li')
        let timer

        offices.forEach(function (office) {
            office.addEventListener('click', function () {
                const url = this.getAttribute('data-url');
                window.location.href = url
            })
        })

        function setTimer () {
            timer = setInterval(function () {
                let activeLi = document.querySelector('#offices .content li.active')
                let nextLi = activeLi.nextElementSibling || document.querySelector('#offices .content li:first-child')
                let activeImage = document.querySelector('#offices figure img.active')
                let nextImage = activeImage.nextElementSibling || document.querySelector('#offices figure img:first-child')

                activeLi.classList.remove('active')
                nextLi.classList.add('active')

                activeImage.classList.remove('active')
                nextImage.classList.add('active')
            }, 6000)
        }

        setTimer()
    }

    initSocial () {
        new Swiper('#social .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 15,
            autoplay: {
                delay: 5000,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                }
            }
        })
    }

    reviewSlider () {
        if (document.querySelector('#reviews')) {
            new Swiper('#reviews .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                autoplay: {
                    delay: 8000,
                },
                navigation: {
                    nextEl: '#reviews .swiper-next',
                    prevEl: '#reviews .swiper-prev',
                },
            })
        }
    }

    propertySlider () {
        if (document.querySelector('#properties')) {
            const slider = new Swiper('#properties .swiper-container', {
                sliderPerView: 1,
                spaceBetween: 50,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },

                },
                navigation: {
                    nextEl: '#properties .swiper-next',
                    prevEl: '#properties .swiper-prev',
                },
            })
            slider.on('slideChangeTransitionStart resize', function () {
                // console.log(slider.slides, slider.realIndex)
                slider.slides.forEach(function (i, index) {
                    if (index < slider.realIndex) {
                        i.classList.add('swiper-slide-prev')
                    }
                })
            })
        }
    }

    projectsSlider () {
        if (document.querySelector('#projects') && document.querySelectorAll('#projects .swiper-slide').length > 1) {
            const slider = new Swiper('#projects .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 1,
                effect: 'slide',
                loop: true,
                autoHeight: true,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                breakpoints: {
                    992: {
                        direction: 'vertical',
                    },
                }
            })

            slider.on('slideChangeTransitionStart resize', function () {
                // console.log(slider.slides, slider.realIndex)
                slider.slides.forEach(function (i, index) {
                    if (index < slider.realIndex) {
                        i.classList.add('swiper-slide-prev')
                    }
                })
            })
        }
    }
}
